/**
 *
 * Merge two arrays, producing a new array with the first argument at the start of the array
 * and the second argument at the end.
 *
 * Either parameter can be undefined/null.
 *
 */
export default function arrayMerge<T>(dst: T[] = [], src: T[] = []) {
  return [...dst, ...src];
}
